/**
 * <ss-reveal> — wraps content that fades+translates in on scroll.
 * Pure progressive enhancement: if JS or IntersectionObserver fails, or if the
 * user prefers reduced motion, content is visible immediately.
 */
class SsReveal extends HTMLElement {
  connectedCallback() {
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add('is-visible');
      return;
    }

    this.classList.add('ss-reveal');

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(this);
  }
}

if (!customElements.get('ss-reveal')) {
  customElements.define('ss-reveal', SsReveal);
}
